<!-- 官方入口 -->
<template>
  <div :class="$style.community">
    <lazy-component>
      <ul v-if="dataSource.length > 0" :class="$style['community-wrap']">
        <li v-for="(el, index) in dataSource" :key="index">
          <a
            :href="el.url || 'javascript:void(0);'"
            :target="el.url && '_blank'"
            @click="onClick(el)"
          >
            <img :src="el.icon" />
          </a>
        </li>
      </ul>
      <van-popup
        v-model="visible"
        get-container="body"
        style="background-color: transparent; overflow: visible;"
      >
        <div :class="$style['community-qrc']">
          <img v-if="qrcImg" :src="qrcImg" />
        </div>
      </van-popup>
    </lazy-component>
  </div>
</template>

<script>
export default {
  name: "TheCommunity",
  props: {
    dataSource: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      visible: false,
      qrcImg: ""
    };
  },
  methods: {
    onClick(el) {
      if (el.url) return;
      if (el.qrc) this.qrcImg = el.qrc;
      this.visible = true;
    }
  }
};
</script>

<style lang="less" module>
.community {
  .background-fill("./images/community-bg.jpg");

  height: 5.91rem;

  &-wrap {
    display: flex;
    justify-content: center;
    gap: 0.3rem;
    margin: 0 auto;

    li img {
      .size(1.45rem, 1.92rem);
    }
  }

  &-qrc {
    .size(2.04rem, 2.05rem);
    .background-fill("./images/qrc-bg.png");

    padding-top: 0.15rem;
    text-align: center;

    img {
      .size(1.56rem);
    }

    &::after {
      .size(0.52rem);
      .background-fill("./images/qrc-close.png");

      content: "";
      position: absolute;
      bottom: -0.64rem;
      left: 0;
      right: 0;
      margin: 0 auto;
      cursor: pointer;
      pointer-events: none;
    }
  }
}
</style>
